import React, { useState } from "react";
import DatePicker from "react-datepicker";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAllCarsAsync } from "../../features/bookings/carrentSlice";
import SearchButton from "../UI/SearchButton";
import { TimePicker } from "antd";
import { useEffect } from "react";
import moment from "moment";
import { diff_hours, slashFormatter } from "../../helpers/helper";
import { useForm } from "../../hooks/useForm";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { getCountryList } from "../../features/bookings/hotelSlice";
import { ready } from "jquery";

const CarrentForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const InputRef = React.useRef(null);

  const [pickUp, setPickUp] = useState("");
  const [hoverPickup, setHoverPickup] = useState(false);

  const customValidate = (errors) => {
    if (pickUp === "") {
      errors.pickupLocation = "Pickup Location Is Required!";
    }
    if (
      diff_hours(
        new Date(state.pickupDate + " " + state.pickupTime),
        new Date(state.dropDate + " " + state.dropTime),
      ) < 5
    )
      errors.hourDiff = "Please atleast 5 hours Journey";
  };

  const {
    state,
    isSubmit,
    formErrors,
    handleFormSubmit,
    checkErrors,
    setState,
    setFormErrors,
  } = useForm({
    val: {
      pickupDate: "",
      pickupTime: "",
      dropDate: "",
      dropTime: "",
      country: "AE",
    },
    inValidate: customValidate,
  });

  const [startPickup, setStartPickup] = useState(
    new Date().setDate(new Date().getDate() + 1),
  );
  const endDateAll = new Date().setFullYear(new Date().getFullYear() + 1);

  const [location, setLocation] = useState("");

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [pickupDate, setPickupDate] = useState("");
  const [pickupTime, setPickUpTime] = useState("");

  const [dropDate, setDropDate] = useState("");
  const [dropTime, setDropTime] = useState("");

  const [searchParams] = useSearchParams();
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams]),
  );
  const countryList = useSelector(getCountryList);
  const setForm = (location, timings, country) => {
    setState(timings);

    const { pickupDate, dropDate, pickupTime, dropTime } = timings || {};

    const { pickUp, latitude, longitude } = location;
    setLocation({ pickup: pickUp, lat: latitude, lng: longitude });
    setLatitude(latitude);
    setLongitude(longitude);

    setPickUp(pickUp);

    setPickupDate(
      new Date(pickupDate).getTime() -
        new Date(pickupDate).getTimezoneOffset() * 60000,
    );
    setDropDate(
      new Date(dropDate).getTime() -
        new Date(dropDate).getTimezoneOffset() * 60000,
    );

    setPickUpTime(moment(pickupTime, "HH:mm"));
    setDropTime(moment(dropTime, "HH:mm"));
  };

  useEffect(() => {
    if (Object.keys(queryData).length > 0) {
      const location = JSON.parse(queryData.location) || {};
      const timings = JSON.parse(queryData.timings) || {};

      if (JSON.parse(sessionStorage.getItem("location")) === null) {
        sessionStorage.setItem("location", queryData.location);
      }

      if (JSON.parse(sessionStorage.getItem("timings")) === null) {
        sessionStorage.setItem("timings", queryData.timings);
      }

      setForm(location, timings);
    } else {
      let timings = JSON.parse(sessionStorage.getItem("timings"));
      let location = JSON.parse(sessionStorage.getItem("location"));

      if (
        timings !== null &&
        timings !== undefined &&
        location !== undefined &&
        location !== null
      ) {
        setForm(location, timings);
      }
    }
  }, [queryData]);

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      let location = {
        latitude,
        longitude,
        pickUp,
      };
      sessionStorage.setItem("location", JSON.stringify(location));
      let timings = state;

      sessionStorage.setItem("timings", JSON.stringify(timings));

      let obj = {
        location: JSON.stringify(location),
        timings: JSON.stringify(timings),
      };
      {
        obj !== undefined &&
          navigate({
            pathname: "/carrent-listing",
            search: `${createSearchParams(obj)}`,
          });
      }
    }
  }, [formErrors, isSubmit]);

  const getlatlong = (value) => {
    let total = value.value.terms.length - 1;

    setPickUp(value.label);

    geocodeByAddress(value.label)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        setLatitude(lat);
        setLongitude(lng);
      });
    setLocation({ pickup: value, lat: latitude, lng: longitude });
  };

  const handlePickupdate = (e) => {
    if (e !== null) {
      setPickupDate(e.getTime() - e.getTimezoneOffset() * 60000);
      setState({
        ...state,
        pickupDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
          .toISOString()
          .split("T")[0],
      });
      delete formErrors["pickupDate"];

      if (new Date(e) > new Date(dropDate)) {
        setDropDate(e.getTime() - e.getTimezoneOffset() * 60000);
        setState({
          ...state,
          pickupDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0],
          dropDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
            .toISOString()
            .split("T")[0],
        });
        delete formErrors["pickupDate"];
        delete formErrors["dropDate"];
      }
    }
  };

  const handleDropdate = (e) => {
    setDropDate(e.getTime() - e.getTimezoneOffset() * 60000);
    setState({
      ...state,
      dropDate: new Date(e.getTime() - e.getTimezoneOffset() * 60000)
        .toISOString()
        .split("T")[0],
    });
    delete formErrors["dropDate"];
  };

  const handlePickupTime = (time, timeString) => {
    setPickUpTime(time);
    setState({
      ...state,
      pickupTime: timeString,
    });
  };

  const handleDropTime = (time, timeString) => {
    setDropTime(time);
    setState({
      ...state,
      dropTime: timeString,
    });
  };

  const handleSelectChange = (e) => {
    setState({ ...state, country: e.target.value });
  };

  const hoverEnterHandler = (type) => {
    if (type === "pickup" && pickUp !== "") {
      setHoverPickup(true);
    }
  };

  const hoverLeaveHandler = (type) => {
    if (type === "pickup") {
      setHoverPickup(false);
    }
  };
  return (
    <>
      <div className="bf-wrap">
        {formErrors?.hourDiff && (
          <span className="bf-error">{formErrors.hourDiff}</span>
        )}
        <form className="bf-form">
          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="33"
                viewBox="0 0 30 33"
                fill="none"
              >
                <path
                  d="M14.2222 33C12.2311 33 10.3704 32.6267 8.64 31.88C6.90963 31.1333 5.40444 30.12 4.12444 28.84C2.84444 27.56 1.83704 26.0489 1.10222 24.3067C0.367408 22.5644 0 20.6978 0 18.7067C0 16.7155 0.367408 14.8607 1.10222 13.1422C1.83704 11.4237 2.84444 9.92443 4.12444 8.64443C5.40444 7.36443 6.90963 6.36295 8.64 5.63999C10.3704 4.91702 12.2311 4.55554 14.2222 4.55554C14.7674 4.55554 15.3067 4.58517 15.84 4.64443C16.3733 4.70369 16.9007 4.79258 17.4222 4.9111V12.3067C17.0904 11.24 16.6519 10.2267 16.1067 9.26665C15.5615 8.30665 14.9333 7.44739 14.2222 6.68888C13.4637 7.32888 12.8237 8.17036 12.3022 9.21332C11.7807 10.2563 11.283 11.6667 10.8089 13.4444H17.4222V15.5778H10.4178C10.323 16.3126 10.2637 16.8992 10.24 17.3378C10.2163 17.7763 10.2044 18.2326 10.2044 18.7067C10.2044 19.2044 10.2163 19.6844 10.24 20.1467C10.2637 20.6089 10.323 21.2074 10.4178 21.9422H18.0622C18.157 21.2074 18.2163 20.6089 18.24 20.1467C18.2637 19.6844 18.2756 19.2044 18.2756 18.7067C18.2756 18.2326 18.2637 17.7763 18.24 17.3378C18.2163 16.8992 18.157 16.3126 18.0622 15.5778H20.2311C20.3022 16.4074 20.3496 17.0415 20.3733 17.48C20.397 17.9185 20.4089 18.3274 20.4089 18.7067C20.4089 19.2281 20.3911 19.72 20.3556 20.1822C20.32 20.6444 20.2667 21.2311 20.1956 21.9422H25.8844C26.0504 21.3733 26.163 20.8459 26.2222 20.36C26.2815 19.8741 26.3111 19.3229 26.3111 18.7067C26.3111 18.0904 26.2815 17.557 26.2222 17.1067C26.163 16.6563 26.0504 16.1467 25.8844 15.5778H28.1244C28.243 16.0755 28.3259 16.5852 28.3733 17.1067C28.4207 17.6281 28.4444 18.1615 28.4444 18.7067C28.4444 20.6978 28.077 22.5644 27.3422 24.3067C26.6074 26.0489 25.6 27.56 24.32 28.84C23.04 30.12 21.5348 31.1333 19.8044 31.88C18.0741 32.6267 16.2133 33 14.2222 33ZM2.56 21.9422H8.21333C8.14222 21.3022 8.10074 20.7274 8.08889 20.2178C8.07704 19.7081 8.07111 19.2044 8.07111 18.7067C8.07111 18.1141 8.08296 17.5867 8.10667 17.1244C8.13037 16.6622 8.17778 16.1467 8.24889 15.5778H2.56C2.39407 16.1467 2.28148 16.6563 2.22222 17.1067C2.16296 17.557 2.13333 18.0904 2.13333 18.7067C2.13333 19.3229 2.16296 19.8741 2.22222 20.36C2.28148 20.8459 2.39407 21.3733 2.56 21.9422ZM11.2 30.5111C10.6074 29.6104 10.0978 28.6385 9.67111 27.5955C9.24444 26.5526 8.88889 25.3792 8.60444 24.0755H3.27111C4.17185 25.7585 5.21481 27.08 6.4 28.04C7.58519 29 9.18519 29.8237 11.2 30.5111ZM3.27111 13.4444H8.64C8.90074 12.1644 9.23259 11.0207 9.63556 10.0133C10.0385 9.00591 10.5481 8.02813 11.1644 7.07999C9.38667 7.53036 7.83407 8.28888 6.50667 9.35554C5.17926 10.4222 4.10074 11.7852 3.27111 13.4444ZM14.2222 30.9378C15.0519 30.0844 15.7452 29.1067 16.3022 28.0044C16.8593 26.9022 17.3156 25.5926 17.6711 24.0755H10.8089C11.1407 25.4978 11.5852 26.7778 12.1422 27.9155C12.6993 29.0533 13.3926 30.0607 14.2222 30.9378ZM17.28 30.4755C18.9867 29.9304 20.5215 29.1126 21.8844 28.0222C23.2474 26.9318 24.3437 25.6163 25.1733 24.0755H19.8756C19.5674 25.3555 19.2059 26.517 18.7911 27.56C18.3763 28.6029 17.8726 29.5748 17.28 30.4755Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M26.7368 7.80393L26.7828 7.72819L26.7131 7.6734C26.3517 7.38915 25.9579 7.17556 25.5319 7.03316C25.1062 6.89085 24.6547 6.82 24.178 6.82C23.7013 6.82 23.2497 6.89085 22.824 7.03316C22.3981 7.17556 22.0042 7.38915 21.6428 7.6734L21.5732 7.72819L21.6192 7.80393C21.887 8.24461 22.2436 8.59761 22.688 8.86194C23.1347 9.12767 23.6321 9.26 24.178 9.26C24.7238 9.26 25.2213 9.12767 25.668 8.86194C26.1124 8.59761 26.469 8.24461 26.7368 7.80393ZM24.1121 13.8752L24.178 13.9329L24.2438 13.8752C25.9173 12.4105 27.1715 11.0465 28.0026 9.78296C28.8336 8.51967 29.2558 7.34063 29.2558 6.248C29.2558 4.62535 28.7473 3.32272 27.7235 2.35145C26.7051 1.38541 25.5219 0.9 24.178 0.9C22.834 0.9 21.6508 1.38541 20.6325 2.35145C19.6086 3.32273 19.1002 4.62535 19.1002 6.248C19.1002 7.34063 19.5223 8.51967 20.3533 9.78296C21.1845 11.0465 22.4386 12.4105 24.1121 13.8752ZM24.178 6.06C24.5062 6.06 24.7886 5.93943 25.0197 5.70171C25.2507 5.46408 25.3669 5.17495 25.3669 4.84C25.3669 4.50505 25.2507 4.21592 25.0197 3.97829C24.7886 3.74057 24.5062 3.62 24.178 3.62C23.8498 3.62 23.5674 3.74057 23.3363 3.97829C23.1052 4.21592 22.9891 4.50505 22.9891 4.84C22.9891 5.17495 23.1052 5.46408 23.3363 5.70171C23.5674 5.93943 23.8498 6.06 24.178 6.06ZM27.1499 8.97089C26.5087 9.99399 25.5195 11.1364 24.1788 12.3981C22.8681 11.1366 21.8857 9.99389 21.2288 8.97C20.5597 7.92714 20.2335 7.02093 20.2335 6.248C20.2335 5.01194 20.6171 4.00887 21.3794 3.22995C22.1434 2.44938 23.0742 2.06 24.178 2.06C25.2817 2.06 26.2126 2.44938 26.9765 3.22995C27.7388 4.00887 28.1224 5.01194 28.1224 6.248C28.1224 7.02155 27.8035 7.92808 27.1499 8.97089Z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.2"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Country</label>
              <select
                name="country"
                className="bf-select"
                value={state.country}
                onChange={handleSelectChange}
                onBlur={(e) => checkErrors(e)}
              >
                {countryList !== undefined &&
                  countryList.map((ele, ind) => (
                    <option key={ind} value={ele.country_code}>
                      {ele.name}
                    </option>
                  ))}
              </select>
              <span className="bf-error">{formErrors?.country}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="32"
                viewBox="0 0 26 32"
                fill="none"
              >
                <path
                  d="M12.8 16C11.04 16 9.6 14.56 9.6 12.8C9.6 11.04 11.04 9.6 12.8 9.6C14.56 9.6 16 11.04 16 12.8C16 14.56 14.56 16 12.8 16ZM22.4 13.12C22.4 7.312 18.16 3.2 12.8 3.2C7.44 3.2 3.2 7.312 3.2 13.12C3.2 16.864 6.32 21.824 12.8 27.744C19.28 21.824 22.4 16.864 22.4 13.12ZM12.8 0C19.52 0 25.6 5.152 25.6 13.12C25.6 18.432 21.328 24.72 12.8 32C4.272 24.72 0 18.432 0 13.12C0 5.152 6.08 0 12.8 0Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Pickup Location</label>
              <span
                onMouseEnter={() => hoverEnterHandler("pickup")}
                onMouseLeave={() => hoverLeaveHandler("pickup")}
                style={{ position: "relative", color: "var(--title-color)" }}
              >
                <GooglePlacesAutocomplete
                  selectProps={{
                    pickUp,
                    onChange: getlatlong,
                    defaultValue:
                      Object.keys(queryData).length > 0
                        ? JSON.parse(queryData.location).pickUp
                        : sessionStorage.getItem("location") !== null
                          ? JSON.parse(sessionStorage.getItem("location"))
                              .pickUp
                          : "",
                    defaultInputValue:
                      Object.keys(queryData).length > 0
                        ? JSON.parse(queryData.location).pickUp
                        : sessionStorage.getItem("location") !== null
                          ? JSON.parse(sessionStorage.getItem("location"))
                              .pickUp
                          : "",
                  }}
                  ref={InputRef}
                  apiKey="AIzaSyBFfyjMZc09fI5_T7rQPS80cJGeh37tclw"
                />
              </span>
              {hoverPickup && <p className="bf-hover-tag">{pickUp}</p>}
            </div>
            <span className="bf-error">{formErrors?.pickupLocation}</span>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="32"
                viewBox="0 0 29 32"
                fill="none"
              >
                <path
                  d="M6.4 14.4H9.6V17.6H6.4V14.4ZM28.8 6.4V28.8C28.8 30.56 27.36 32 25.6 32H3.2C1.424 32 0 30.56 0 28.8L0.016 6.4C0.016 4.64 1.424 3.2 3.2 3.2H4.8V0H8V3.2H20.8V0H24V3.2H25.6C27.36 3.2 28.8 4.64 28.8 6.4ZM3.2 9.6H25.6V6.4H3.2V9.6ZM25.6 28.8V12.8H3.2V28.8H25.6ZM19.2 17.6H22.4V14.4H19.2V17.6ZM12.8 17.6H16V14.4H12.8V17.6Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Pickup Date</label>
              <DatePicker
                placeholderText="PickUp date"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                name="pickupDate"
                autoComplete="off"
                minDate={startPickup}
                maxDate={endDateAll}
                selected={Date.parse(state.pickupDate)}
                value={
                  state.pickupDate !== ""
                    ? slashFormatter(state.pickupDate)
                    : ""
                }
                onBlur={(e) => checkErrors(e)}
                className="bf-input"
                onChange={handlePickupdate}
              />
              <span className="bf-error">{formErrors?.pickupDate}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M21.0952 23.4266L23.4266 21.1704L17.6357 15.342V8.15981H14.5523V16.6204L21.0952 23.4266ZM15.9812 32C13.7752 32 11.7007 31.5801 9.75793 30.7403C7.81512 29.9005 6.12299 28.7599 4.68155 27.3185C3.24011 25.877 2.09949 24.1849 1.25969 22.2421C0.419898 20.2993 0 18.2248 0 16.0188C0 13.8128 0.419898 11.7383 1.25969 9.79554C2.09949 7.85272 3.24011 6.1606 4.68155 4.71915C6.12299 3.27771 7.81512 2.13083 9.75793 1.2785C11.7007 0.426165 13.7752 0 15.9812 0C18.1872 0 20.2617 0.426165 22.2045 1.2785C24.1473 2.13083 25.8394 3.27771 27.2808 4.71915C28.7223 6.1606 29.8692 7.85272 30.7215 9.79554C31.5738 11.7383 32 13.8128 32 16.0188C32 18.2248 31.5738 20.2993 30.7215 22.2421C29.8692 24.1849 28.7223 25.877 27.2808 27.3185C25.8394 28.7599 24.1473 29.9005 22.2045 30.7403C20.2617 31.5801 18.1872 32 15.9812 32ZM15.9436 28.4653C19.378 28.4653 22.3173 27.2558 24.7615 24.8367C27.2056 22.4175 28.4277 19.4783 28.4277 16.0188C28.4277 12.5844 27.2056 9.65139 24.7615 7.21974C22.3173 4.78809 19.3905 3.57227 15.9812 3.57227C12.5468 3.57227 9.61379 4.78809 7.18214 7.21974C4.75049 9.65139 3.53467 12.5844 3.53467 16.0188C3.53467 19.4783 4.75049 22.4175 7.18214 24.8367C9.61379 27.2558 12.5343 28.4653 15.9436 28.4653Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Pickup Time</label>
              <TimePicker
                bordered={false}
                format={"HH:mm"}
                use12Hours
                onChange={handlePickupTime}
                name="pickupTime"
                onBlur={(e) => checkErrors(e)}
                value={pickupTime}
              />
              <span className="bf-error">{formErrors?.pickupTime}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="28"
                viewBox="0 0 32 28"
                fill="none"
              >
                <path
                  d="M4.77328 7.53029C6.17648 8.69988 7.51421 9.82269 8.86128 10.9174C9.07644 11.0952 9.13257 11.1888 8.91741 11.4227C8.53387 11.8344 8.18775 12.2742 7.84162 12.7139C7.72936 12.8543 7.66388 12.8636 7.51421 12.742C5.05392 10.6835 2.58428 8.62503 0.114639 6.56655C-0.0631006 6.41684 -0.0163271 6.35134 0.133348 6.22971C2.59363 4.18994 5.05392 2.14082 7.50485 0.0916959C7.66388 -0.0392982 7.72936 -0.0299415 7.85098 0.119766C8.21581 0.578246 8.58064 1.02737 8.97354 1.46713C9.13257 1.64491 9.06709 1.71977 8.91741 1.8414C7.64517 2.89871 6.37293 3.96538 5.10069 5.02269C5.0165 5.09754 4.93231 5.16304 4.79199 5.28468C4.99779 5.28468 5.1194 5.28468 5.24101 5.28468C10.4048 5.28468 15.5686 5.22854 20.7418 5.30339C25.2975 5.35953 28.7026 7.4648 30.7887 11.5163C34.1096 17.963 30.2835 25.9256 23.1927 27.4695C22.3788 27.6473 21.5556 27.7408 20.723 27.7408C14.4835 27.7408 8.24387 27.7408 2.00429 27.7502C1.74236 27.7502 1.66752 27.694 1.67687 27.4227C1.69558 26.8894 1.69558 26.3467 1.67687 25.8133C1.66752 25.5513 1.74236 25.4952 2.00429 25.4952C6.82196 25.5046 11.6303 25.5046 16.4479 25.5046C17.8512 25.5046 19.2544 25.5046 20.6576 25.5046C25.0543 25.4952 28.6371 22.5946 29.5632 18.2999C30.611 13.4344 27.2058 8.46596 22.2853 7.68C21.7801 7.59579 21.2656 7.54901 20.7511 7.54901C15.5312 7.54901 10.3019 7.54901 5.08198 7.54901C5.00715 7.53029 4.94166 7.53029 4.77328 7.53029Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">DropOff Date</label>
              <DatePicker
                placeholderText="Dropoff date"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                name="dropDate"
                autoComplete="off"
                minDate={pickupDate}
                maxDate={endDateAll}
                selected={Date.parse(state.dropDate)}
                value={
                  state.dropDate !== "" ? slashFormatter(state.dropDate) : ""
                }
                onBlur={(e) => checkErrors(e)}
                className="bf-input"
                onChange={handleDropdate}
              />
              <span className="bf-error">{formErrors?.dropDate}</span>
            </div>
          </div>

          <div className="bf-field">
            <div className="bf-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M21.0952 23.4266L23.4266 21.1704L17.6357 15.342V8.15981H14.5523V16.6204L21.0952 23.4266ZM15.9812 32C13.7752 32 11.7007 31.5801 9.75793 30.7403C7.81512 29.9005 6.12299 28.7599 4.68155 27.3185C3.24011 25.877 2.09949 24.1849 1.25969 22.2421C0.419898 20.2993 0 18.2248 0 16.0188C0 13.8128 0.419898 11.7383 1.25969 9.79554C2.09949 7.85272 3.24011 6.1606 4.68155 4.71915C6.12299 3.27771 7.81512 2.13083 9.75793 1.2785C11.7007 0.426165 13.7752 0 15.9812 0C18.1872 0 20.2617 0.426165 22.2045 1.2785C24.1473 2.13083 25.8394 3.27771 27.2808 4.71915C28.7223 6.1606 29.8692 7.85272 30.7215 9.79554C31.5738 11.7383 32 13.8128 32 16.0188C32 18.2248 31.5738 20.2993 30.7215 22.2421C29.8692 24.1849 28.7223 25.877 27.2808 27.3185C25.8394 28.7599 24.1473 29.9005 22.2045 30.7403C20.2617 31.5801 18.1872 32 15.9812 32ZM15.9436 28.4653C19.378 28.4653 22.3173 27.2558 24.7615 24.8367C27.2056 22.4175 28.4277 19.4783 28.4277 16.0188C28.4277 12.5844 27.2056 9.65139 24.7615 7.21974C22.3173 4.78809 19.3905 3.57227 15.9812 3.57227C12.5468 3.57227 9.61379 4.78809 7.18214 7.21974C4.75049 9.65139 3.53467 12.5844 3.53467 16.0188C3.53467 19.4783 4.75049 22.4175 7.18214 24.8367C9.61379 27.2558 12.5343 28.4653 15.9436 28.4653Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <div className="bf-control">
              <label className="bf-label" htmlFor="">Drop off Time</label>
              <TimePicker
                bordered={false}
                format={"HH:mm"}
                use12Hours
                onChange={handleDropTime}
                name="dropTime"
                onBlur={(e) => checkErrors(e)}
                value={dropTime}
              />
              <span className="bf-error">{formErrors?.dropTime}</span>
            </div>
          </div>

          <div className="bf-submit">
            <SearchButton func={handleFormSubmit} />
          </div>
        </form>
      </div>
    </>
  );
};

export default CarrentForm;